import { UtilService } from 'app/_services/util.service';
import * as angular from 'angular';
import { BigDecimal } from '../custom';
import * as net from 'net';

export class ProductUploadWizardService {
    constructor(private utilService: UtilService) {}

    public getMappedData(stageFourData): ManualProductUploadDto {
        let data = {
            products: [],
            competitions: []
        };

        if (
            angular.isUndefined(stageFourData) ||
            stageFourData === null ||
            angular.equals(stageFourData, {}) ||
            !stageFourData.transferData
        ) {
            return data;
        }

        angular.forEach(stageFourData.transferData, (productWrapper) => {
            let dataProducts = {
                accessPointRefId: productWrapper.networkPoint.id,
                networkPointDto: productWrapper.selectedNetworkPoint,
                period: productWrapper.runtime,
                bundled: productWrapper.bundled,
                periodType: productWrapper.productType,
                bookedCapacity: this.getBookedCapacity(
                    productWrapper.bookedCapacity
                ),
                products: []
            };

            angular.forEach(productWrapper.products, (product) => {
                let defaultPriceUnit = product.regulatedCapacityTariff;

                let dataProduct: ProductDataDto = <ProductDataDto>{
                    capacityCategory: product.categoryType,
                    quantityDto: {
                        value: product.amount.value,
                        unit: product.amount.unit
                    },
                    assignmentRestrictions: product.assignmentRestrictions,
                    regulatedChargeValue: this.getOriginalValue(
                        product.regulatedCapacityTariff
                    ),
                    regulatedChargeUnit: this.getPriceUnitDto(
                        product.regulatedCapacityTariff,
                        defaultPriceUnit
                    ),
                    operatingChargeValue: this.getOriginalValue(
                        product.measuringOperationsFee
                    ),
                    operatingChargeUnit: this.getPriceUnitDto(
                        product.measuringOperationsFee,
                        defaultPriceUnit
                    ),
                    accountingChargeValue: this.getOriginalValue(
                        product.billingFee
                    ),
                    accountingChargeUnit: this.getPriceUnitDto(
                        product.billingFee,
                        defaultPriceUnit
                    ),
                    gasQualityConversionChargeValue: this.getOriginalValue(
                        product.gasQualityConversionFee
                    ),
                    gasQualityConversionChargeUnit: this.getPriceUnitDto(
                        product.gasQualityConversionFee,
                        defaultPriceUnit
                    ),
                    measurementChargeValue: this.getOriginalValue(
                        product.measuringFee
                    ),
                    measurementChargeUnit: this.getPriceUnitDto(
                        product.measuringFee,
                        defaultPriceUnit
                    ),
                    bioGasChargeValue: this.getOriginalValue(
                        product.biogasRedistributionLevy
                    ),
                    bioGasChargeUnit: this.getPriceUnitDto(
                        product.biogasRedistributionLevy,
                        defaultPriceUnit
                    ),
                    balancingChargeValue: this.getOriginalValue(
                        product.balancingCharge
                    ),
                    balancingChargeUnit: this.getPriceUnitDto(
                        product.balancingCharge,
                        defaultPriceUnit
                    ),
                    commodityFeeValue: this.getOriginalValue(
                        product.commodityFee
                    ),
                    commodityFeeUnit: this.getPriceUnitDto(
                        product.commodityFee,
                        defaultPriceUnit
                    ),
                    startingPriceValue: this.getOriginalValue(
                        product.startingPrice
                    ),
                    startingPriceUnit: this.getPriceUnitDto(
                        product.startingPrice,
                        defaultPriceUnit
                    ),
                    largePriceStepValue: this.getOriginalValue(
                        product.largePriceStep
                    ),
                    largePriceStepUnit: this.getPriceUnitDto(
                        product.largePriceStep,
                        defaultPriceUnit
                    ),
                    numberOfSmallPriceSteps: product.numberOfSmallPriceSteps,
                    offerId: product.offerId,
                    preventUnbundledMarketing:
                        product.preventUnbundledMarketing,
                    slotId: this.getSlotId(product),
                    splitFactor: product.splitFactor,
                    maximumBidFactor: !!product.maximumBidFactor
                        ? product.maximumBidFactor
                        : null,
                    auctionNote: product.auctionNote,
                    rolloverData: [],
                    calendar: productWrapper.calendar
                };

                angular.forEach(product.rolloverDataSet, (rolloverDataSet) => {
                    if (rolloverDataSet.selected) {
                        const rolloverData = {
                            offerId: rolloverDataSet.offerId,
                            targetRuntime: rolloverDataSet.targetRuntime,
                            regulatedTariff:
                                !!rolloverDataSet.regulatedCapacityTariff
                                    ? rolloverDataSet.regulatedCapacityTariff
                                          .originalValue
                                    : null,
                            startingPrice: !!rolloverDataSet.startingPrice
                                ? rolloverDataSet.startingPrice.originalValue
                                : null,
                            balancingCharge: !!rolloverDataSet.balancingCharge
                                ? rolloverDataSet.balancingCharge.originalValue
                                : null,
                            commodityFee: !!rolloverDataSet.commodityFee
                                ? rolloverDataSet.commodityFee.originalValue
                                : null
                        };
                        dataProduct.rolloverData.push(rolloverData);
                    }
                });

                dataProducts.products.push(dataProduct);
            });
            data.products.push(dataProducts);
        });

        if (
            !!stageFourData.competitions &&
            stageFourData.competitions.length > 0
        ) {
            angular.forEach(stageFourData.competitions, function (competition) {
                let competitionObj = {
                    totalCapacity: competition.constraint.value,
                    idsOfCompetingProducts: competition.offerIds
                };
                data.competitions.push(competitionObj);
            });
        }
        return data;
    }

    public mapDataToWizard(data: ManualProductUploadDto): any {
        let returnData: any = {
            transferData: []
        };

        angular.forEach(data.products, (product) => {
            let productTemplate: any = {
                wizardGuid: null,
                isEditMode: true,
                bundled: product.bundled,
                tsoFilter: [],
                selectedNetworkPoint: {},
                networkPoint: {},
                products: [],
                productType: null,
                runtime: {},
                competitions: []
            };
            productTemplate.wizardGuid = this.utilService.generateGuid();
            productTemplate.tsoFilter.push(product.tsoName);

            if (product.bundled) {
                product.networkPointDto.bundled = true;
            }

            productTemplate.selectedNetworkPoint = product.networkPointDto;

            productTemplate.networkPoint = product.networkPointDto;
            productTemplate.productType = product.periodType;
            productTemplate.runtime = product.period;

            angular.forEach(product.products, (innerProduct) => {
                let innerProductTemplate = {
                    categoryTypes: {},
                    categoryType: null,
                    amount: {},
                    assignmentRestrictions: '',
                    regulatedCapacityTariff: {},
                    startingPrice: {},
                    largePriceStep: {},
                    biogasRedistributionLevy: {},
                    balancingCharge: {},
                    commodityFee: {},
                    measuringOperationsFee: {},
                    billingFee: {},
                    gasQualityConversionFee: {},
                    numberOfSmallPriceSteps: null,
                    offerId: null,
                    preventUnbundledMarketing: null,
                    slotId: null,
                    splitFactor: null,
                    maximumBidFactor: null,
                    auctionNote: null,
                    rolloverDataSetEnabled: false,
                    priceSettingsVisible: false,
                    auctionSettingsVisible: false,
                    rolloverDataSet: [],
                    possibleSlotIds: []
                };

                if (
                    this.getDirectionForTso(
                        product.tsoName,
                        product.networkPointDto
                    ) == 0
                ) {
                    innerProductTemplate.categoryTypes =
                        product.networkPointDto.capacityCategories0;
                }
                if (
                    this.getDirectionForTso(
                        product.tsoName,
                        product.networkPointDto
                    ) == 1
                ) {
                    innerProductTemplate.categoryTypes =
                        product.networkPointDto.capacityCategories1;
                }

                innerProductTemplate.categoryType =
                    innerProduct.capacityCategory;
                innerProductTemplate.amount = innerProduct.quantityDto;

                if (innerProduct.assignmentRestrictions) {
                    innerProductTemplate.assignmentRestrictions =
                        innerProduct.assignmentRestrictions;
                } else {
                    innerProductTemplate.assignmentRestrictions = ' ';
                }

                innerProductTemplate.regulatedCapacityTariff =
                    this.mapToPriceDto(
                        innerProduct.regulatedChargeValue,
                        innerProduct.regulatedChargeUnit
                    );
                innerProductTemplate.startingPrice = this.mapToPriceDto(
                    innerProduct.startingPriceValue,
                    innerProduct.startingPriceUnit
                );
                innerProductTemplate.largePriceStep = this.mapToPriceDto(
                    innerProduct.largePriceStepValue,
                    innerProduct.largePriceStepUnit
                );

                innerProductTemplate.biogasRedistributionLevy =
                    this.mapToPriceDto(
                        innerProduct.bioGasChargeValue,
                        innerProduct.bioGasChargeUnit
                    );
                innerProductTemplate.balancingCharge = this.mapToPriceDto(
                    innerProduct.balancingChargeValue,
                    innerProduct.balancingChargeUnit
                );
                innerProductTemplate.commodityFee = this.mapToPriceDto(
                    innerProduct.commodityFeeValue,
                    innerProduct.commodityFeeUnit
                );
                innerProductTemplate.measuringOperationsFee =
                    this.mapToPriceDto(
                        innerProduct.measurementChargeValue,
                        innerProduct.measurementChargeUnit
                    );
                innerProductTemplate.billingFee = this.mapToPriceDto(
                    innerProduct.accountingChargeValue,
                    innerProduct.accountingChargeUnit
                );
                innerProductTemplate.gasQualityConversionFee =
                    this.mapToPriceDto(
                        innerProduct.gasQualityConversionChargeValue,
                        innerProduct.gasQualityConversionChargeUnit
                    );

                innerProductTemplate.numberOfSmallPriceSteps =
                    innerProduct.numberOfSmallPriceSteps;

                innerProductTemplate.offerId = innerProduct.offerId;
                innerProductTemplate.preventUnbundledMarketing =
                    innerProduct.preventUnbundledMarketing;
                innerProductTemplate.slotId = innerProduct.slotId;

                innerProductTemplate.splitFactor = innerProduct.splitFactor;
                innerProductTemplate.maximumBidFactor =
                    innerProduct.maximumBidFactor;
                innerProductTemplate.auctionNote = innerProduct.auctionNote;

                innerProductTemplate.rolloverDataSetEnabled =
                    innerProduct.rolloverData.length > 0;

                innerProductTemplate.rolloverDataSet = [];

                angular.forEach(
                    innerProduct.rolloverData,
                    (rollOverDataSet) => {
                        innerProductTemplate.rolloverDataSet.push(
                            this.mapRollOverData(
                                rollOverDataSet,
                                innerProduct.regulatedChargeUnit
                            )
                        );
                    }
                );

                innerProductTemplate.priceSettingsVisible = !!(
                    innerProductTemplate.gasQualityConversionFee ||
                    innerProductTemplate.billingFee ||
                    innerProductTemplate.measuringOperationsFee ||
                    innerProductTemplate.biogasRedistributionLevy ||
                    innerProductTemplate.balancingCharge ||
                    innerProductTemplate.commodityFee ||
                    innerProductTemplate.startingPrice ||
                    innerProductTemplate.largePriceStep ||
                    (productTemplate.productType != 'WITHINDAY' &&
                        productTemplate.productType != 'DAY')
                );

                innerProductTemplate.auctionSettingsVisible = !!(
                    innerProduct.auctionNote ||
                    innerProduct.assignmentRestrictions
                );

                productTemplate.products.push(innerProductTemplate);
            });

            if (!!data.competitions) {
                productTemplate.competitions = this.mapCompetitionData(
                    data.competitions,
                    productTemplate.selectedNetworkPoint.physicalUnit
                );
            }

            returnData.transferData.push(productTemplate);
        });

        return returnData;
    }

    private mapCompetitionData(
        competitions: ProductCompetitionDto[],
        unit: PhysicalUnit
    ): any[] {
        let mappedCompetitions: any[] = [];

        angular.forEach(competitions, (competition) => {
            let mappedCompetition = {
                constraint: {
                    value: competition.totalCapacity,
                    unit: unit
                },
                offerIds: []
            };

            angular.forEach(competition.idsOfCompetingProducts, (id) => {
                mappedCompetition.offerIds.push(id);
            });
            mappedCompetitions.push(mappedCompetition);
        });

        return mappedCompetitions;
    }

    private mapRollOverData(
        rollOverSet: ProductRolloverDataDto,
        unit: PriceUnitDto
    ): any {
        let mappedRollOverSet = {
            selected: true,
            targetRuntime: rollOverSet.targetRuntime,
            offerId: rollOverSet.offerId,
            regulatedCapacityTariff: this.mapToPriceDto(
                rollOverSet.regulatedTariff,
                unit
            ),
            startingPrice: this.mapToPriceDto(rollOverSet.startingPrice, unit),
            balancingCharge: this.mapToPriceDto(
                rollOverSet.balancingCharge,
                unit
            ),
            commodityFee: this.mapToPriceDto(rollOverSet.commodityFee, unit)
        };

        if (angular.isUndefined(mappedRollOverSet.startingPrice)) {
            mappedRollOverSet.startingPrice = {
                unit: null,
                value: null,
                originalUnit: null,
                originalValue: null
            };
        }
        if (angular.isUndefined(mappedRollOverSet.balancingCharge)) {
            mappedRollOverSet.balancingCharge = {
                unit: null,
                value: null,
                originalUnit: null,
                originalValue: null
            };
        }
        if (angular.isUndefined(mappedRollOverSet.commodityFee)) {
            mappedRollOverSet.commodityFee = {
                unit: null,
                value: null,
                originalUnit: null,
                originalValue: null
            };
        }

        return mappedRollOverSet;
    }

    private getDirectionForTso(
        tsoName: string,
        networkPoint: NetworkPointDto
    ): number {
        if (tsoName == networkPoint.tso0Name) {
            return 0;
        }
        if (tsoName == networkPoint.tso1Name) {
            return 1;
        }
    }

    private mapToPriceDto(value: BigDecimal, unit: PriceUnitDto): PriceDto {
        if (value && unit) {
            let priceDto: PriceDto = {
                value: {
                    value: value.value,
                    floatingPointNumber: value.floatingPointNumber
                },
                originalValue: {
                    value: value.value,
                    floatingPointNumber: value.floatingPointNumber
                },
                unit: unit,
                originalUnit: unit
            };
            return priceDto;
        }
    }

    private getBookedCapacity(item) {
        if (
            angular.isUndefined(item) ||
            angular.isUndefined(item.value.value)
        ) {
            return null;
        }
        let mapBookedCapacity = item.value.value;

        return mapBookedCapacity;
    }

    public getPriceUnitDto(unit, defaultUnit) {
        let item;
        if (
            angular.isUndefined(unit) ||
            angular.isUndefined(unit.originalUnit)
        ) {
            item = defaultUnit;
        } else {
            item = unit;
        }
        let priceUnitDto = {
            currency: item.originalUnit.currency,
            currencySubunit: item.originalUnit.currencySubunit,
            label: item.originalUnit.label,
            physicalUnit: item.originalUnit.physicalUnit,
            periodType: item.originalUnit.periodType,
            unspecificPeriod: item.originalUnit.unspecificPeriod
        };
        return priceUnitDto;
    }

    public getOriginalValue(item) {
        if (
            angular.isUndefined(item) ||
            angular.isUndefined(item.originalValue)
        ) {
            return null;
        }
        return item.originalValue;
    }

    private getSlotId(product) {
        if (angular.isUndefined(product) || !product.slotId) {
            return 1;
        }
        return product.slotId;
    }
}

angular
    .module('app')
    .service('productUploadWizardService', ProductUploadWizardService);
